/**
 * GC / self-perform extras from BP-700-9000-1 Indirect Cost Estimate,
 * sheet "GC and Self-Perform":
 *   D = Cost Item, F = Qty, H = Duration (months)
 *
 * The workbook is a 20-month construction takeoff. We scale Duration to this
 * job's months and hide rows the Excel left empty (qty 0 / duration 0).
 * Suggested qty + duration are the estimate base; the user can override.
 */

export const GC_EXTRAS_SOURCE = 'BP-700-9000-1 Indirect Cost Estimate — GC and Self-Perform';
export const GC_EXTRAS_STORAGE = 'evm-gc-extras-v2';
export const TEMPLATE_SCHEDULE_MONTHS = 20;

/** templateQty / templateDuration come from columns F and H of the Excel. */
export const GC_INDIRECT_EXTRAS = [
  { id: '1.01', category: '1. Site Management', name: 'Project/Site Manager', unit: '$/Month', kind: 'staff', templateQty: 4, templateDuration: 17.1875, comment: '4 PM (Electrical, Mechanical, Piping, Civil)' },
  { id: '1.02', category: '1. Site Management', name: 'Construction Manager', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 20 },
  { id: '1.03', category: '1. Site Management', name: 'Area Superintendents', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '1.04', category: '1. Site Management', name: 'Mechanical Superintendent/Coordinators', unit: '$/Month', kind: 'staff', templateQty: 3, templateDuration: 20.6667, comment: '(Structure, Mechanical, Piping)' },
  { id: '1.05', category: '1. Site Management', name: 'Electrical Superintendent/Coordinators', unit: '$/Month', kind: 'staff', templateQty: 2, templateDuration: 23 },
  { id: '1.06', category: '1. Site Management', name: 'Civil Superintendent/Coordinators', unit: '$/Month', kind: 'staff', templateQty: 1.25, templateDuration: 20 },
  { id: '1.07', category: '1. Site Management', name: 'Construction/Site Engineers', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '1.08', category: '1. Site Management', name: 'Project Controls Manager', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 17.5 },
  { id: '1.09', category: '1. Site Management', name: 'Scheduler(s)', unit: '$/Month', kind: 'staff', templateQty: 2, templateDuration: 16, comment: '(SRG, LGL)' },
  { id: '1.10', category: '1. Site Management', name: 'Cost Controller(s)', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '1.11', category: '1. Site Management', name: 'Document Controllers', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 15 },
  { id: '1.12', category: '1. Site Management', name: 'Site Administrative and Clerical Staff', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 15.5 },
  { id: '1.13', category: '1. Site Management', name: 'Project Director', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 16 },
  { id: '1.14', category: '1. Site Management', name: 'Architectural Supervisor', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 20 },
  { id: '1.15', category: '1. Site Management', name: 'Piping Supervisor', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 12 },
  { id: '1.16', category: '1. Site Management', name: 'Piping Shop Supervisor', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 8 },
  { id: '1.17', category: '1. Site Management', name: 'Rigging Supervisor', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 15.5 },
  { id: '1.18', category: '1. Site Management', name: 'Level 1 / Coordinator', unit: '$/Month', kind: 'staff', templateQty: 5, templateDuration: 14.4, comment: '(Piping, Structure, Electrical, Inst, Mechanical)' },
  { id: '1.19', category: '1. Site Management', name: 'Level 2 / Coordinator', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '1.20', category: '1. Site Management', name: 'Junior Civil Surveyor', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '1.21', category: '1. Site Management', name: 'Senior Civil Surveyor', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '1.22', category: '1. Site Management', name: 'Estimator', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 1.25 },
  { id: '1.23', category: '1. Site Management', name: 'Contract Administrator', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 10 },

  { id: '2.01', category: '2. Safety & Environmental', name: 'Site Safety Manager', unit: '$/Month', kind: 'staff', templateQty: 1, templateDuration: 11 },
  { id: '2.02', category: '2. Safety & Environmental', name: 'Safety Officers', unit: '$/Month', kind: 'staff', templateQty: 4, templateDuration: 18 },
  { id: '2.03', category: '2. Safety & Environmental', name: 'Safety Training Program', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '2.04', category: '2. Safety & Environmental', name: 'PPE Program', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '2.05', category: '2. Safety & Environmental', name: 'First Aid Facilities', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '2.06', category: '2. Safety & Environmental', name: 'Site Medical Services', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '2.07', category: '2. Safety & Environmental', name: 'Environmental Monitoring', unit: '$/Month', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '2.08', category: '2. Safety & Environmental', name: 'Dust Control Program', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '2.09', category: '2. Safety & Environmental', name: 'Spill Response Equipment', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },

  { id: '3.01', category: '3. Construction Facilities', name: 'Construction Offices Trailer 24 x 60 (LGL)', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.02', category: '3. Construction Facilities', name: 'General Contractor Trailer Complex', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.03', category: '3. Construction Facilities', name: 'Vendor/Supplier Trailers', unit: '$/Month', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '3.04', category: '3. Construction Facilities', name: 'Owner / Engineer Office Facilities', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.05', category: '3. Construction Facilities', name: 'Tool Cribs', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.06', category: '3. Construction Facilities', name: 'Lunchrooms', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.07', category: '3. Construction Facilities', name: 'Toilet Facilities', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.08', category: '3. Construction Facilities', name: 'Locker Facilities', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.09', category: '3. Construction Facilities', name: 'Laydown Areas', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.10', category: '3. Construction Facilities', name: 'Parking Areas', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '3.11', category: '3. Construction Facilities', name: 'Meeting Area / Muster Point', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '3.12', category: '3. Construction Facilities', name: 'Concrete Washout Zone', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },

  { id: '4.01', category: '4. Temporary Utilities', name: 'Temporary Electrical Power Distribution', unit: 'NA', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '4.02', category: '4. Temporary Utilities', name: 'Temporary Water Distribution', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '4.03', category: '4. Temporary Utilities', name: 'Temporary Sewer Collection', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '4.04', category: '4. Temporary Utilities', name: 'Temporary Site Stormwater and Drainage Collection System', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '4.05', category: '4. Temporary Utilities', name: 'Temporary Lighting (Indoor & Outdoor)', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '4.06', category: '4. Temporary Utilities', name: 'Internet Distribution & Site WebCams System', unit: '$/Month', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '4.07', category: '4. Temporary Utilities', name: 'Telecommunications Distribution', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '4.08', category: '4. Temporary Utilities', name: 'Generator Set(s) & Fuel', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '4.09', category: '4. Temporary Utilities', name: 'IT Network and Servers', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '4.10', category: '4. Temporary Utilities', name: 'Document Control Plotters and Printers', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },

  { id: '5.01', category: '5. Site Logistics', name: 'Temporary Security Fence and Gates', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '5.02', category: '5. Site Logistics', name: 'Security Guards', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '5.03', category: '5. Site Logistics', name: 'Snow Removal Services', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '5.04', category: '5. Site Logistics', name: 'Road Maintenance Services', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '5.05', category: '5. Site Logistics', name: 'Waste Management Services', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '5.06', category: '5. Site Logistics', name: 'Dumpster Service', unit: '$/Month', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '5.07', category: '5. Site Logistics', name: 'Janitorial Services', unit: '$/Month', kind: 'cost', templateQty: 0, templateDuration: 0 },

  { id: '6.01', category: '6. Material Management', name: 'Receiving & Material Manager', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '6.02', category: '6. Material Management', name: 'Warehouse Personnel', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '6.03', category: '6. Material Management', name: 'Receiving Inspectors', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 16.5 },
  { id: '6.04', category: '6. Material Management', name: 'Material Handling Equipment', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '6.05', category: '6. Material Management', name: 'Outside Storage Areas', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '6.06', category: '6. Material Management', name: 'Warehouse Officer', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 42 },
  { id: '6.07', category: '6. Material Management', name: 'Procurement Manager', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '6.08', category: '6. Material Management', name: 'Procurement Agents', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 12 },

  { id: '7.01', category: '7. Construction Equipment', name: 'Site Pickup Trucks', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '7.02', category: '7. Construction Equipment', name: 'Forklifts', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '7.03', category: '7. Construction Equipment', name: 'Scissor Lifts', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '7.04', category: '7. Construction Equipment', name: 'Boom Trucks', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '7.05', category: '7. Construction Equipment', name: 'Lighting Towers', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '7.06', category: '7. Construction Equipment', name: 'Small Utility Equipment', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '7.07', category: '7. Construction Equipment', name: 'Fuel Distribution System', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },

  { id: '8.01', category: '8. Quality Assurance & Testing', name: 'QA/QC Manager', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 21 },
  { id: '8.02', category: '8. Quality Assurance & Testing', name: 'Mechanical Inspectors', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 44 },
  { id: '8.03', category: '8. Quality Assurance & Testing', name: 'Structural Inspectors', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 17 },
  { id: '8.04', category: '8. Quality Assurance & Testing', name: 'Electrical Inspectors', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 15 },
  { id: '8.05', category: '8. Quality Assurance & Testing', name: 'Instrumentation Inspectors', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '8.06', category: '8. Quality Assurance & Testing', name: 'Survey Crew', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 16.5 },
  { id: '8.07', category: '8. Quality Assurance & Testing', name: 'Materials Testing', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '8.08', category: '8. Quality Assurance & Testing', name: 'NDT Testing', unit: 'Lump Sum', kind: 'cost', templateQty: 0, templateDuration: 0 },
  { id: '8.09', category: '8. Quality Assurance & Testing', name: 'Third Party Inspection Services', unit: '$/Month', kind: 'cost', templateQty: 0, templateDuration: 0 },

  { id: '9.01', category: '9. Pre-Commissioning & Turnover', name: 'Pre-Commissioning Manager', unit: '$/Month', kind: 'staff', templateQty: 0, templateDuration: 0 },
  { id: '9.02', category: '9. Pre-Commissioning & Turnover', name: 'Systems Completion Team', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '9.03', category: '9. Pre-Commissioning & Turnover', name: 'Punchlist Management Team', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '9.04', category: '9. Pre-Commissioning & Turnover', name: 'Turnover Documentation Team', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '9.05', category: '9. Pre-Commissioning & Turnover', name: 'Flushing & Cleaning Programs & Reporting', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '9.07', category: '9. Commissioning & Startup', name: 'Functional Testing Support', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },

  { id: '10.01', category: '10. Corporate Costs', name: 'Builders Risk Insurance', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.02', category: '10. Corporate Costs', name: 'General Liability Insurance', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.03', category: '10. Corporate Costs', name: 'Performance Bond FOR 100%', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.04', category: '10. Corporate Costs', name: 'Payment Bonds', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.05', category: '10. Corporate Costs', name: 'Home Office Overhead', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.06', category: '10. Corporate Costs', name: 'Corporate Management', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.07', category: '10. Corporate Costs', name: 'Accounting & Payroll', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.08', category: '10. Corporate Costs', name: 'Information Technology', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.09', category: '10. Corporate Costs', name: 'Human Resources', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 },
  { id: '10.10', category: '10. Corporate Costs', name: 'Legal Services', unit: 'Lump Sum', kind: 'cost', templateQty: 1, templateDuration: 1 }
];

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export function projectMonthKeys(dates = []) {
  return [...new Set((dates || []).map((d) => String(d || '').slice(0, 7)).filter((m) => /^\d{4}-\d{2}$/.test(m)))].sort();
}

export function suggestedForItem(item, projectMonths) {
  const months = Math.max(0, Number(projectMonths) || 0);
  const scale = months > 0 ? months / TEMPLATE_SCHEDULE_MONTHS : 1;
  const tQty = Number(item.templateQty);
  const tDur = Number(item.templateDuration);
  const hasQty = Number.isFinite(tQty) && tQty > 0;
  const hasDur = Number.isFinite(tDur) && tDur > 0;
  const lump = item.kind === 'cost' || /lump/i.test(item.unit || '');

  if (lump) {
    if (!hasQty && !hasDur) return { qty: 0, duration: 0, include: false };
    return {
      qty: hasQty ? tQty : 1,
      duration: hasDur ? tDur : 1,
      include: true
    };
  }

  let qty = hasQty ? tQty : 0;
  let duration = hasDur ? tDur : 0;
  if (!hasQty && hasDur) {
    if (tDur > TEMPLATE_SCHEDULE_MONTHS) {
      qty = Math.max(1, Math.round(tDur / TEMPLATE_SCHEDULE_MONTHS));
      duration = TEMPLATE_SCHEDULE_MONTHS;
    } else {
      qty = 1;
    }
  }
  duration = round2(duration * scale);
  if (duration > 0 && months > 0) duration = Math.min(duration, months);
  qty = round2(qty);
  return { qty, duration, include: qty > 0 && duration > 0 };
}

function overrideNum(map, id) {
  const v = map?.[id];
  if (v === '' || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function resolveExtras(cfg, projectMonths) {
  return GC_INDIRECT_EXTRAS.map((item) => {
    const suggested = suggestedForItem(item, projectMonths);
    const qtyOv = overrideNum(cfg?.qty, item.id);
    const durOv = overrideNum(cfg?.duration, item.id);
    const included = cfg?.included && Object.prototype.hasOwnProperty.call(cfg.included, item.id)
      ? cfg.included[item.id] !== false
      : suggested.include;
    const qty = qtyOv != null ? qtyOv : suggested.qty;
    const duration = durOv != null ? durOv : suggested.duration;
    return {
      ...item,
      suggested,
      qty,
      duration,
      include: included,
      overridden: qtyOv != null || durOv != null
    };
  });
}

export function selectedExtras(cfg, projectMonths) {
  return resolveExtras(cfg, projectMonths).filter((item) => item.include && (Number(item.qty) > 0 || Number(item.duration) > 0));
}

export function monthlySpread(months, qty, duration, { lump = false } = {}) {
  const keys = months || [];
  const out = keys.map(() => 0);
  const q = Number(qty) || 0;
  if (!q || !keys.length) return out;
  if (lump) {
    out[0] = q;
    return out;
  }
  let left = Math.max(0, Number(duration) || 0);
  for (let i = 0; i < keys.length && left > 0; i += 1) {
    const part = Math.min(1, left);
    out[i] = round2(q * part);
    left -= part;
  }
  return out;
}

export function extrasHorizontalRows(cfg, months, projectMonths) {
  return selectedExtras(cfg, projectMonths).map((item) => ({
    id: item.id,
    label: `${item.id} ${item.name}`,
    values: monthlySpread(months, item.qty, item.duration, { lump: item.kind === 'cost' })
  }));
}

export function defaultExtrasCfg() {
  return { included: {}, qty: {}, duration: {} };
}

export function loadExtrasCfg(jobNumber) {
  const fallback = defaultExtrasCfg();
  try {
    const raw = JSON.parse(localStorage.getItem(`${GC_EXTRAS_STORAGE}-${jobNumber}`) || 'null');
    if (!raw || typeof raw !== 'object') return fallback;
    return {
      included: raw.included && typeof raw.included === 'object' ? raw.included : {},
      qty: raw.qty && typeof raw.qty === 'object' ? raw.qty : {},
      duration: raw.duration && typeof raw.duration === 'object' ? raw.duration : {}
    };
  } catch {
    return fallback;
  }
}

export function saveExtrasCfg(jobNumber, cfg) {
  try {
    localStorage.setItem(`${GC_EXTRAS_STORAGE}-${jobNumber}`, JSON.stringify({
      included: cfg?.included || {},
      qty: cfg?.qty || {},
      duration: cfg?.duration || {}
    }));
  } catch { /* ignore */ }
}

export function extrasByCategory(items = GC_INDIRECT_EXTRAS) {
  const groups = [];
  const seen = new Map();
  items.forEach((item) => {
    let g = seen.get(item.category);
    if (!g) {
      g = { category: item.category, items: [] };
      seen.set(item.category, g);
      groups.push(g);
    }
    g.items.push(item);
  });
  return groups;
}

export function extrasNoteLines(jobNumber, projectMonths) {
  const months = Number(projectMonths) || 0;
  return [
    `Job ${jobNumber || ''}`,
    `Source: ${GC_EXTRAS_SOURCE}, columns D (Cost Item), F (Qty), H (Duration).`,
    `Excel takeoff is a ${TEMPLATE_SCHEDULE_MONTHS}-month construction schedule. This job is ${months || '—'} months — Duration is scaled ${TEMPLATE_SCHEDULE_MONTHS} → ${months || '—'}. Qty is the Excel headcount (or 1 when the sheet left Qty blank but Duration was filled).`,
    'Empty Excel rows (qty 0 and duration 0) stay hidden. Override Qty or Duration any time — that is the estimate base for indirects.',
    `Generated ${new Date().toLocaleString()}.`
  ];
}

export function extrasTableRows(cfg, projectMonths) {
  return selectedExtras(cfg, projectMonths).map((item) => ([
    item.id,
    item.category,
    item.name,
    item.unit,
    item.qty,
    item.duration,
    round2((Number(item.qty) || 0) * (Number(item.duration) || 0)),
    item.kind === 'staff' ? 'Staff' : 'Cost'
  ]));
}
